export class DescontosFormaPagamento
{
	formaPagamentoMensalidade: string
	valorPercentual: string
	descontoMensalidade?: number
}